// src/api/axiosInstance.js
import axios from "axios";
import Swal from "sweetalert2";

let hasShownGlobalError = false;

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

// ✅ Request interceptor for token
axiosInstance.interceptors.request.use(
  config => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["x-access-token"] = token;
    }
    return config;
  },
  error => Promise.reject(error)
);

// ✅ Response interceptor for global errors
axiosInstance.interceptors.response.use(
  response => response,
  error => {
    const isNetworkError = !error.response;

    // Handle network/server error
    if (isNetworkError && !hasShownGlobalError) {
      hasShownGlobalError = true;

      Swal.fire({
        title: "Server Error",
        text: "Cannot connect to the server. Please try again later.",
        icon: "error",
      });

      setTimeout(() => {
        hasShownGlobalError = false;
      }, 5000);
    }

    // ✅ Handle Invalid Token case
    if (error?.response?.data === "Invalid Token" || error?.response?.data?.message === "Invalid Token") {
      // Clear token and redirect to login
      localStorage.removeItem("token");
      Swal.fire({
        title: "Session Expired",
        text: "Your session has expired. Please log in again.",
        icon: "warning",
        confirmButtonText: "OK",
      }).then(() => {
        window.location.href = "/login";
      });
    }

    console.error("API Error:", error?.response || error);
    return Promise.reject(error);
  }
);

export default axiosInstance;
